import React from 'react';
import PropTypes from 'prop-types';
import { selectSystemProps, Typography, getTokensPropType, useThemeTokens } from '@telus-uds/components-base';
import styled from 'styled-components';
import { htmlAttrs, transformGradient } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([htmlAttrs]);
const BadgeContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Badge__BadgeContainer",
  componentId: "components-web__sc-tsiuo2-0"
})(["background:", ";border:", ";display:inline-flex;justify-content:center;align-items:center;height:fit-content;padding:", ";border-radius:", ";width:fit-content;", ""], _ref => {
  let {
    background
  } = _ref;
  return background;
}, _ref2 => {
  let {
    border
  } = _ref2;
  return border;
}, _ref3 => {
  let {
    padding
  } = _ref3;
  return padding;
}, _ref4 => {
  let {
    radius
  } = _ref4;
  return radius;
}, _ref5 => {
  let {
    isOutlineOffer,
    isAlternative,
    gradient
  } = _ref5;
  return (isOutlineOffer || isAlternative) && `
    > div {
      background: ${gradient};
	    -webkit-background-clip: text;
	    ${gradient && '-webkit-text-fill-color: transparent;'}
    }`;
});
const fontSizeMapping = {
  12: 'micro',
  14: 'small',
  16: 'h6'
};
const Badge = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  let {
    children,
    tokens,
    variant = {},
    ...rest
  } = _ref6;
  const {
    backgroundColor,
    gradient,
    borderColor,
    borderRadius,
    borderWidth,
    color,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    fontName,
    fontWeight,
    fontSize
  } = useThemeTokens('Badge', tokens, variant);
  const semanticGradient = gradient && transformGradient(gradient);
  const {
    outline,
    purpose,
    alternative
  } = variant;
  let background = backgroundColor;
  const isOutlineOffer = purpose === 'offer' && outline;
  if ((isOutlineOffer || alternative) && gradient) {
    background = `linear-gradient(#fff 0 0) padding-box, ${semanticGradient} border-box`;
  } else if (purpose === 'offer' && gradient) {
    background = semanticGradient;
  }
  return /*#__PURE__*/_jsx(BadgeContainer, {
    isOutlineOffer: isOutlineOffer,
    isAlternative: alternative,
    padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
    radius: `${borderRadius}px`,
    background: background,
    fontName: fontName,
    fontWeight: fontWeight,
    gradient: semanticGradient,
    border: `${borderWidth}px solid ${borderColor}`,
    ref: ref,
    ...selectProps(rest),
    children: /*#__PURE__*/_jsx(Typography, {
      tokens: {
        fontName,
        fontWeight,
        color
      },
      variant: {
        size: fontSizeMapping[fontSize]
      },
      children: children
    })
  });
});
Badge.displayName = 'Badge';
Badge.propTypes = {
  ...selectedSystemPropTypes,
  children: PropTypes.node,
  tokens: getTokensPropType('Badge'),
  variant: PropTypes.exact({
    outline: PropTypes.bool,
    purpose: PropTypes.oneOf(['offer', 'editorial']),
    alternative: PropTypes.bool,
    inverse: PropTypes.bool
  })
};
export default Badge;